$(function()
{
    $('#main > .container .col-md-5').on('click', function () {
        if(!$(this).hasClass('job-seeker-panel')) {
            $('input').blur();
        }
        $(this).closest('.container').addClass('hovered');
        $('.eeactiside').removeClass('eeactiside').addClass('eeinactiside');
        $(this).addClass('eeactiside').removeClass('eeinactiside');
    });
    $('body').css({
        'display': 'block'
    });
});